<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button class="pill next-pill-button" @click="addInternalPool">
        <span>Add internal pool</span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>



  <div class="main_wrapper ion-padding">
    <div class="container">
      <div class="auth-header">
        <div class="auth-heading">
          <h1>Private Internal Pool</h1>
        </div>
      </div>

      <div class="preferred_user_info_wrapper page_padding_top"
        v-if="preferredLocums[0]?.internalPoolInvitations?.length >= 0">

        <div class="user_card" v-for="preferredLocum in preferredLocums[0].internalPoolInvitations"
          v-bind:key="preferredLocum.id">
          <div class="image_wrapper cursor-pointer" @click="userInfoModalOpen(preferredLocum)">
            <el-avatar :size="'small'" :shape="'circle'" :src="preferredLocum?.user?.image"
              v-if="preferredLocum?.userId && preferredLocum?.user?.image" />
            <el-avatar :size="'small'" :shape="'circle'" icon="el-icon-user-solid" v-else></el-avatar>
          </div>

          <div class="right cursor-pointer" @click="userInfoModalOpen(preferredLocum)">
            <div class="locum_name"> {{ getPreferredLocumName(preferredLocum) }}</div>
            <div class="locum_status">{{ getInvitationStatus(preferredLocum) }}</div>
          </div>

          <el-button class="button_more icon-button text-only-black" icon="el-icon-more"
            @click="openDrawer(preferredLocum)"></el-button>
        </div>

      </div>
      <div class="preferred_user_info_wrapper page_padding_top" v-else>
       Please add an internal pool for your pharmacy. No internal pool has been added yet.
      </div>
      <div class="load_more" v-if="loading">
        <i class="el-icon-loading"></i>
      </div>
    </div>
    <div class="background-circles">
      <div class="circle circle-2"></div>
      <div class="circle circle-1"></div>
      <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
    </div>

  </div>
  <modal-user-info :modalName="'userInfoModal'" :options="userInfoModal"></modal-user-info>

  <!-- Drawer -->
  <el-drawer custom-class="bottom_drop_up menu-drawer" v-model="drawerVisible" :append-to-body="true"
    :with-header="false" :direction="'btt'" :destroy-on-close="true" size="30%">
    <div class="drawer-content">
      <el-button type="transparent" class="menu_item red" @click="removePreferredLocum">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M17.5 4.98332C14.725 4.70832 11.9333 4.56665 9.15 4.56665C7.5 4.56665 5.85 4.64998 4.2 4.81665L2.5 4.98332"
            stroke="rgb(var(--locumate-clr-danger)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path
            d="M7.08331 4.14163L7.26665 3.04996C7.39998 2.25829 7.49998 1.66663 8.90831 1.66663H11.0916C12.5 1.66663 12.6083 2.29163 12.7333 3.05829L12.9166 4.14163"
            stroke="rgb(var(--locumate-clr-danger)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path
            d="M15.7084 7.6167L15.1667 16.0084C15.075 17.3167 15 18.3334 12.675 18.3334H7.32502C5.00002 18.3334 4.92502 17.3167 4.83335 16.0084L4.29169 7.6167"
            stroke="rgb(var(--locumate-clr-danger)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M8.60834 13.75H11.3833" stroke="rgb(var(--locumate-clr-danger)" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round" />
          <path d="M7.91669 10.4166H12.0834" stroke="rgb(var(--locumate-clr-danger)" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span v-if="selectedLocum.rejectedAt != null">Remove {{ selectedLocum.firstName }} {{ selectedLocum.lastName }} </span>
        <span v-else-if="selectedLocum.acceptedAt == null && selectedLocum.rejectedAt == null">Cancel invitation {{ selectedLocum.firstName }} {{ selectedLocum.lastName }} </span>
        <span v-else>Remove {{ selectedLocum.firstName }} {{ selectedLocum.lastName }} </span>
      </el-button>
    </div>
  </el-drawer>
</template>
  
<script>
import {
  ref,
  onMounted,
  inject,
  getCurrentInstance
} from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
import { ElMessageBox, ElMessage  } from "@/components/Vendor/Element";
addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import {
  IonToolbar,
} from "@ionic/vue";
import { UserInfoModal } from "@/modals/modals";
import { useStore } from "vuex";

import {
  useRouter,
  onBeforeRouteLeave
} from "vue-router";
import SvgIcon from '@/components/Svg/SvgIcon.vue'; 
export default {
  components: {
    IonToolbar,
    "modal-user-info": UserInfoModal,
    SvgIcon
  },
  directives: {},
  setup() {
    const mainMenuShow = inject("mainMenuShow");

    const $store = useStore();
    const $router = useRouter();
    const $modals = inject("$modals");
    const loading = ref(false);
    const preferredLocums = ref();
    const instance = getCurrentInstance();

    const drawerVisible = ref(false)
    const selectedLocum = ref(null)
    const user = $store.getters.GET_USER_DATA;
    /* @todo preferredLocumEnabled will be available from the api */
    if (user.preferredLocumEnabled === undefined) {
      user.preferredLocumEnabled = true;
    }

    if (user.preferredLocumEnabled === false || user.preferredLocumEnabled === undefined) {
      goBack();
    }


    loading.value = true;

    const goBack = () => {
      $router.push({
        name: "profile",
      });
    };

    const userInfoModal = ref({
      name: "userInfo",
      user: {},
    });

    const userInfoModalOpen = (user) => {
      console.log("🚀 ~ userInfoModalOpen ~ user:", user.user)
      if(user.userId != null){
        userInfoModal.value.user = user.user;
        $modals.open("userInfoModal");
        console.log("yo yo yo ")
      }else{
        ElMessage.error(`Invited to ${instance?.appContext.config.globalProperties.$filters.appName() }`);
      }
     
    };

    const loadPreferredLocums = () => {

      loading.value = true;

      (async () => {
        try {
          let data = await $store.dispatch("FETCH_INTERNAL_POOL_FOR_PHARMACY");
          console.log("🚀 ~ data:", data)
          preferredLocums.value = data;
          console.log(preferredLocums.value, 'preferredlocum')
          loading.value = false;


        } catch (error) {
          console.log(error);
        }

      })();

    }

    const getInvitationStatus = (preferredLocum) => {

      if (!preferredLocum.acceptedAt && preferredLocum.userId
      ) {
        return `Invited to ${instance?.appContext.config.globalProperties.$filters.appName()} and already Onboarded`;
      }

      if (preferredLocum.acceptedAt && preferredLocum.userId != null && preferredLocum.user.lastActivity === "") {
        return `Accepted but not onboarded to ${instance?.appContext.config.globalProperties.$filters.appName()}`;
      }

      if (preferredLocum.acceptedAt && preferredLocum.userId == null) {
        return `Accepted but not onboarded to ${instance?.appContext.config.globalProperties.$filters.appName()}`;
      }


      if (preferredLocum.acceptedAt != null && preferredLocum.userId != null) {
        return `Accepted and onboarded with ${instance?.appContext.config.globalProperties.$filters.appName()}`;
      }

      

      if(preferredLocum.rejectedAt !=null){
        return `Rejected invitation`;      
      }

      // return `Invited to ${instance?.appContext.config.globalProperties.$filters.appName()}`;
      return `Invite sent`;

    }

    const getPreferredLocumName = (preferredLocum) => {

      if (preferredLocum.userId) {
        return preferredLocum?.user?.name;
      }

      return preferredLocum.email;
    }

    onMounted(() => {
      mainMenuShow(true);
      loadPreferredLocums();

    });

    const viewProfile = (preferredLocum) => {
      console.log("This is preffered locum", preferredLocum)
      $router.push({
        name: "profile_preferred_locum",
        params: { invitationId: preferredLocum.id }
      });
    }


    onBeforeRouteLeave((to, from, next) => {
      (async () => {
        try {
          next(true);
        } catch (error) {
          next(false);
          console.log(error);
        }
      })();
    });

    const addInternalPool = () => {
      $router.push({
        name: "invite_internal_pool",
      });
    }


    const openDrawer = (locum) => {
      console.log("🚀 ~ openDrawer ~ locum:", locum)
      selectedLocum.value = locum
      drawerVisible.value = true
    }

    const removePreferredLocum = async () => {
      if (!selectedLocum.value) return

      // Determine action type and messages
      let confirmMessage = ''
      let successMessage = ''

      const locum = selectedLocum.value

      if (
        (locum.acceptedAt == null && locum.rejectedAt == null) ||
        locum.rejectedAt != null
      ) {
        // Cancel invitation
        confirmMessage = `Are you sure you want to cancel the invitation for ${locum.firstName} ${locum.lastName}?`
        successMessage = `Invitation for ${locum.firstName} ${locum.lastName} cancelled successfully!`
      } else if (locum.acceptedAt != null && locum.userId != null) {
        // Remove from internal pool
        confirmMessage = `Are you sure you want to remove ${locum.firstName} ${locum.lastName} from the internal pool?`
        successMessage = `${locum.firstName} ${locum.lastName} removed from internal pool successfully!`
      } else {
        // Fallback
        confirmMessage = `Are you sure you want to remove ${locum.firstName} ${locum.lastName}?`
        successMessage = `Removed ${locum.firstName} ${locum.lastName} successfully!`
      }

      try {
        // Ask for confirmation
        await ElMessageBox.confirm(confirmMessage, 'Confirmation', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          type: 'warning',
        })

        // Perform action based on type
        if (
          (locum.acceptedAt == null && locum.rejectedAt == null) ||
          locum.rejectedAt != null || (locum.acceptedAt != null && locum.userId == null)
        ) {
          await $store.dispatch('CANCEL_INTERNAL_POOL_INVITATION', {
            invitationId: locum.id,
          })
        } else if (locum.acceptedAt != null && locum.userId != null) {
          console.log("removing internal pool", locum.internalPoolListId, locum.userId)
          await $store.dispatch('REMOVE_INTERNAL_POOL', {
            listId: locum.internalPoolListId,
            userId: locum.userId,
          })
        }

        // Show success message
        ElMessage({
          type: 'success',
          message: successMessage,
        })
        loadPreferredLocums();
        drawerVisible.value = false
      } catch (error) {
        console.log('Action cancelled or failed')
      }
    }




    return {
      user,
      goBack,
      viewProfile,
      loading,
      preferredLocums,
      getInvitationStatus,
      getPreferredLocumName,
      userInfoModalOpen,
      userInfoModal,
      addInternalPool,
      openDrawer,
      removePreferredLocum,
      drawerVisible,
      selectedLocum
    };
  },
};
</script>
  